export default function appendNestedParams(searchParams, params, prefix = "") {
  for (const [key, value] of Object.entries(params)) {
    const fullKey = prefix ? `${prefix}[${key}]` : key;

    if (value === null || value === undefined || value === "") continue;

    if (Array.isArray(value)) {
      value.forEach(item => searchParams.append(`${fullKey}[]`, item));
    } else if (typeof value === "object") {
      appendNestedParams(searchParams, value, fullKey);
    } else {
      searchParams.append(fullKey, value);
    }
  }
}
